import { Component, forwardRef, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PrFormService } from '@app/components/pr-form/pr-form.service';
import { AssetDao } from '@app/dao/asset/asset.dao';
import { UserDao } from '@app/dao/user/user.dao';
import { NotificationsService } from '@app/components/notification/NotificationsService';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Subject, switchMap } from 'rxjs';
import { PrCrowdfundingFormBuilder } from './ea-crowdfunding-form.builder';

@Component({
    selector: 'ea-crowdfunding-form',
    templateUrl: './ea-crowdfunding-form.component.html',
    styleUrls: ['./ea-crowdfunding-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaCrowdfundingFormComponent),
        },
    ],
    standalone: false
})
export class EaCrowdfundingFormComponent
  extends PrCrowdfundingFormBuilder
  implements OnInit
{
  users: any[];
  references: any;
  groupes: any[];
  sources: any[];
  managers: any[];
  _ = _;
  doneSubject: Subject<void> = new Subject<void>();
  tabChanged: BehaviorSubject<any> = new BehaviorSubject(null);
  changeTab: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(
    protected formConstructor: PrFormConstructor,
    private userDao: UserDao,
    private assetDao: AssetDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    combineLatest([
      this.userDao.getCouple(),
      this.assetDao.getReferences(),
      this.assetDao.getProviderByType(this.entity.type?.toUpperCase()),
    ]).subscribe(([users, references, managers]) => {
      this.users = users;
      this.references = references;
      this.sources = references[0];
      this.managers = managers;
      if (this.entity.owners && this.entity.owners.length > 0)
        this.form.get('owners').setValue(this.buildInitialOwners(this.entity));
    });
  }

  get title() {
    return this.generateTitle(
      'Modifier le crowdfunding',
      'Ajout d’un crowdfunding',
    );
  }

  generateTitle(editTitle: string, addTitle: string) {
    if (!this.entity || !this.entity.id) return addTitle;
    if (!this.entity.label || this.entity.label === '') return editTitle;
    return `${editTitle} “${this.entity.label}”`;
  }

  ///REFACTO
  selectType(type) {
    this.form.controls.type.setValue(type);
    this.form.updateValueAndValidity();
    this.assetDao.getProviderByType(type).subscribe(res => {
      this.managers = res;
    });
  }

  onSubmit() {
    this.displayErrors();

    this.selectErrorInput();

    if (this.form.invalid) {
      this.changeTab.next('FIRST');
      return;
    }

    //Fetch every form controls value
    let formDTOExtraction = this.extract();
    this.prFormService.loading();
    this.assetDao
      .proposeManagerProvider(formDTOExtraction, this.managers)
      .pipe(switchMap(() => this.assetDao.saveAssets(formDTOExtraction)))
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          this.notificationService.success('La sauvegarde a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La sauvegarde a échoué');
        },
      );
  }

  onCancel() {
    this.prFormService.close();
  }

  onTabChange(isLastTab: boolean) {
    this.tabChanged.next(isLastTab);
  }

  nextTab() {
    this.changeTab.next('NEXT');
  }
}
